const CURRENCY_SCALE = 100

export function toCurrencyCents(value: string | number | null | undefined): number {
  if (value === null || value === undefined || value === "") return 0

  const normalized = typeof value === "string" ? value.replace(",", ".") : value
  const numericValue = Number(normalized)
  if (!Number.isFinite(numericValue)) return 0
  // Shift the decimal exponent before rounding, avoiding binary products such as
  // 1.005 * 100 = 100.49999999999999. Match the server's decimal ROUND_HALF_UP.
  const [coefficient, exponent = "0"] = String(normalized).split(/[eE]/)
  const scaled = Number(`${coefficient}e${Number(exponent) + 2}`)
  return Math.sign(scaled) * Math.round(Math.abs(scaled))
}

export function centsToDecimal(cents: number): string {
  return (cents / CURRENCY_SCALE).toFixed(2)
}

export function availableAllocationCents(
  purchaseOrderOutstandingCents: number,
  productionStatementOutstandingCents: number
): number {
  if (productionStatementOutstandingCents <= 0) return productionStatementOutstandingCents
  return Math.max(0, Math.min(purchaseOrderOutstandingCents, productionStatementOutstandingCents))
}

export function validateAllocationCents(
  amountCents: number,
  productionStatementAvailableCents: number
): string | null {
  if (
    Math.sign(amountCents) !== Math.sign(productionStatementAvailableCents) ||
    Math.abs(amountCents) > Math.abs(productionStatementAvailableCents)
  ) {
    return "Het te koppelen bedrag moet binnen het openstaande PV-bedrag vallen, met hetzelfde teken."
  }
  return null
}

export function validateApprovalTotalCents(totalCents: number, sourceCents: number): string | null {
  return totalCents < Math.min(0, sourceCents) || totalCents > Math.max(0, sourceCents)
    ? "Het gekoppelde totaal valt buiten het bedrag van de klant."
    : null
}
